import { push } from "connected-react-router";
import React from "react";
import { useDispatch } from "react-redux";
import { ROUTE_PATH } from "../../app/constants";
import { Button } from "../../components/RegularComponents";

export const PrincipalBroker = (props) => {
    const dispatch = useDispatch();
    
    const handleNext = isPrincipalBroker => () => {
        // dispatch(setIsPrincipalBroker(isPrincipalBroker))

        const nextPath = isPrincipalBroker ? ROUTE_PATH.MRA_HAS_ROLE_WITH_RJSC : ROUTE_PATH.MRA_PRINCIPAL_BROKER_NO
        dispatch(push(`${ROUTE_PATH.MRA_APP}${nextPath}`))
    }
    return (
        <div className="container" >
            {/* Title */}
            <div className="row" >
                <div className="col-xs-12 col-lg-8">
                    <h1>Principal Broker</h1>
                </div>
            </div>

            {/* Information Paragraphs */}
            <div className="row">
                <div className="col-lg-8">
                    <p>Before you apply, your company needs to identify a principal broker for your brokerage.
                        The principal broker must be a director, partner, officer or sole proprietor at the company.
                    </p>

                    <p>The principal broker is responsible for managing the brokerage, mortgage brokers, and associate mortgage brokers.</p>
                
                    <p>The principal broker needs to complete this application for the brokerage and all licence applications for mortgage brokers and associate mortgage brokers.</p>

                    <p>Are you the principal broker for your brokerage?</p>
                </div>
            </div>
            {/* Yes/No Answer */}
            <div className="row">
                <div className="col-lg-2 ">
                    <Button
                        className={"ns-btn-yes-no btn-default"}
                        buttonType="primary_regular"
                        onClick={handleNext(true)}
                        text={"Yes"}
                    />
                </div>

                <div className="col-xs-3">
                    <Button
                        className={"ns-btn-yes-no btn-default"}
                        buttonType="primary_regular"
                        onClick={handleNext(false)}
                        text={"No"}
                    />
                </div>
            </div>
        </div>
    )
}